import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PAGE_NAMES } from '../../../core/helpers/constants';
import { IPermission } from '../../../core/models/auth.models';
import { AppService } from '../../../store/app.service';

@Component({
  selector: 'app-searches-main',
  templateUrl: './searches-main.component.html',
  styleUrls: ['./searches-main.component.scss']
})
export class SearchesMainComponent implements OnInit {
  doWhat: IPermission = {} as IPermission;
  active = 1;
  mode = 'CREATE_SEARCH';
  private savedSearchId: string | null = null;

  constructor(private appService: AppService,
    private route: ActivatedRoute,
    private router: Router) {
      this.route.params.subscribe(params => {
        this.savedSearchId = params.id ?? null;
        this.active = this.savedSearchId ? 2 : 1;
        this.mode = this.savedSearchId ? 'MODIFY_SEARCH' : 'CREATE_SEARCH';
      });
     }

  ngOnInit(): void {
    this.appService.setPageTitle$('SEARCHES');
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Searches);
  }

  searchSaved() {
    this.active = 1;
    this.savedSearchId = null;
    this.router.navigate(['/pages/searches']);
  }

  onCreateSearch() {
    this.mode = 'CREATE_SEARCH';
    this.active = 2;
    this.savedSearchId = null;
    this.router.navigate(['/pages/searches']);
  }

  onTabChange(nextTabId: number) {
    this.active = nextTabId;

    if (nextTabId === 1) {
      this.savedSearchId = null;
      this.mode = 'CREATE_SEARCH';
      this.router.navigate(['/pages/searches']);
      return;
    }

    this.mode = this.savedSearchId ? 'MODIFY_SEARCH' : 'CREATE_SEARCH';

    if (this.savedSearchId) {
      this.router.navigate(['/pages/searches', this.savedSearchId]);
    }
  }

}
